var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function ($metadata, value) {pug_mixins["th"] = pug_interp = function(column){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var attr = (column.$metadata || {})['attr.head']
var cls = [];
var sort = column.$orderby ? (column.$orderby.dir > 0 ? 'ascending' : 'descending') : 'none';
if (column.header) {
cls.push(column.header['class']);
}
if (column.sortable) {
cls.push('sortable');
cls.push('clickable');
attributes['tabindex'] = '0';
}
if (column.$orderby) {
cls.push('orderby');
}
cls = cls.join(' ');
pug_html = pug_html + "\u003Cth" + (pug.attrs(pug.merge([{"class": pug.classes([cls], [true]),"title": pug.escape((typeof column.$text !== 'undefined') ? column.$text : ''),"aria-sort": pug.escape(sort)},attributes,attr]), true)) + "\u003E";
if (column.$orderby) {
if (column.$orderby.dir > 0) {
pug_html = pug_html + "\u003Cspan class=\"grid-asc\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"grid-des\"\u003E\u003C\u002Fspan\u003E";
}
}
if ((column && column.$html)) {
pug_html = pug_html + (null == (pug_interp = column.$html) ? "" : pug_interp);
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = (typeof column.$text != 'undefined') ? column.$text : (column.property || column)) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fth\u003E";
};
pug_mixins["td"] = pug_interp = function(row, column){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var attr = (column.$metadata || {})['attr.body']
var cls = [];
if (column.cell) {
cls.push(column.cell['class']);
}
cls = cls.join(' ');
pug_html = pug_html + "\u003Ctd" + (pug.attrs(pug.merge([{"class": pug.classes([cls], [true])},attributes,attr]), true)) + "\u003E";
var res = row[column.property]
if ((res && res.$html)) {
pug_html = pug_html + (null == (pug_interp = res.$html) ? "" : pug_interp);
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = res) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
};
pug_html = pug_html + "\u003Ctable" + (pug.attrs(pug.merge([{"class": "table table-hover grid"},$metadata]), true)) + "\u003E\u003Cthead\u003E\u003Ctr class=\"table__row--header\"\u003E";
// iterate locals['columns'] || []
;(function(){
  var $$obj = locals['columns'] || [];
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var column = $$obj[index];
pug_mixins["th"](column);
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var column = $$obj[index];
pug_mixins["th"](column);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E";
// iterate value
;(function(){
  var $$obj = value;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var row = $$obj[i];
var attr = (row.$metadata || {}).attr
pug_html = pug_html + "\u003Ctr" + (pug.attrs(pug.merge([{"class": "table__row--body"},attr]), true)) + "\u003E";
// iterate locals['columns'] || []
;(function(){
  var $$obj = locals['columns'] || [];
  if ('number' == typeof $$obj.length) {
      for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
        var column = $$obj[j];
pug_mixins["td"](row, column);
      }
  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;
      var column = $$obj[j];
pug_mixins["td"](row, column);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var row = $$obj[i];
var attr = (row.$metadata || {}).attr
pug_html = pug_html + "\u003Ctr" + (pug.attrs(pug.merge([{"class": "table__row--body"},attr]), true)) + "\u003E";
// iterate locals['columns'] || []
;(function(){
  var $$obj = locals['columns'] || [];
  if ('number' == typeof $$obj.length) {
      for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
        var column = $$obj[j];
pug_mixins["td"](row, column);
      }
  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;
      var column = $$obj[j];
pug_mixins["td"](row, column);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E";}.call(this,"$metadata" in locals_for_with?locals_for_with.$metadata:typeof $metadata!=="undefined"?$metadata:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;